<template>
  <div class="employeeRoster page-customer">
    <div class="employeeRosterTable">
      <el-table
        :data="tableData"
        :max-height="tableHeight - 180"
        :cell-style="columnStyle"
        v-loading="listLoading"
      >
        <!-- <el-table-column align="center" type="selection" width="40px"></el-table-column> -->
        <el-table-column align="center" label="序号" width="50">
          <template slot-scope="{ $index }">
            <span>{{
              (Number(infoQuery.currpage) - 1) * Number(infoQuery.pagecount) +
              Number($index) +
              1
            }}</span>
          </template>
        </el-table-column>
        <el-table-column
          align="center"
          label="项目名称"
          prop="StrObjName"
          min-width="140px"
          fit
          show-overflow-tooltip
        >
          <template slot-scope="scope">
            <span
              v-if="checkPermission(['customerList_dtl'], permissionLists)"
              style="color: #19bd92"
              @click="handdle(scope.row)"
              >{{ scope.row.StrObjName ? scope.row.StrObjName : "-" }}</span
            >
            <span v-else>{{
              scope.row.StrObjName ? scope.row.StrObjName : "-"
            }}</span>
          </template>
        </el-table-column>
        <el-table-column
          align="center"
          label="服务中心"
          prop="StrSrvCent"
          min-width="120px"
          fit
          show-overflow-tooltip
        >
          <template slot-scope="scope">
            <span>{{ scope.row.StrSrvCent ? scope.row.StrSrvCent : "-" }}</span>
          </template>
        </el-table-column>
        <!-- <el-table-column align="center" label="公司" prop="StrBlCmp">
            <template slot-scope="scope">
              {{scope.row.StrBlCmp ? scope.row.StrBlCmp : '-'}}
            </template>
          </el-table-column> -->
        <el-table-column
          align="center"
          label="业务立项部门"
          prop="StrObjInstName"
          min-width="130px"
          fit
          show-overflow-tooltip
        >
          <template slot-scope="scope">
            <span>{{
              scope.row.StrObjInstName ? scope.row.StrObjInstName : "-"
            }}</span>
          </template>
        </el-table-column>
        <el-table-column
          align="center"
          label="项目类别"
          prop="StrProjectType"
          fit
          show-overflow-tooltip
        >
          <template slot-scope="scope">
            <span>{{
              scope.row.StrProjectType ? scope.row.StrProjectType : "-"
            }}</span>
          </template>
        </el-table-column>
        <el-table-column
          align="center"
          label="负责客服"
          prop="StrUserName"
          fit
          show-overflow-tooltip
        >
          <template slot-scope="scope">
            <span>{{
              scope.row.StrUserName ? scope.row.StrUserName : "-"
            }}</span>
          </template>
        </el-table-column>
        <el-table-column align="center" label="项目状态" prop="StrBusiStat">
        </el-table-column>
        <el-table-column align="center" sortable label="在职人数" prop="IsWork">
          <template slot-scope="scope">
            <span>{{ scope.row.IsWork ? scope.row.IsWork : "-" }}</span>
          </template>
        </el-table-column>
        <el-table-column
          align="center"
          sortable
          label="离职人数"
          prop="NotWork"
        >
          <template slot-scope="scope">
            <span>{{ scope.row.NotWork ? scope.row.NotWork : "-" }}</span>
          </template>
        </el-table-column>
        <el-table-column
          align="center"
          sortable
          label="未发薪数"
          prop="EmpNotSalary"
        >
          <template slot-scope="scope">
            <span>{{ scope.row.EmpNotSalary ? scope.row.EmpNotSalary : "-" }}</span>
          </template>
        </el-table-column>
        <el-table-column
          align="center"
          sortable
          label="黑名单数"
          prop="IsBlack"
        >
          <template slot-scope="scope">
            <span>{{ scope.row.IsBlack ? scope.row.IsBlack : "-" }}</span>
          </template>
        </el-table-column>
        <el-table-column align="center" sortable label="雇员总数" prop="count">
          <template slot-scope="scope">
            <span>{{ scope.row.count ? scope.row.count : "-" }}</span>
          </template>
        </el-table-column>
        <el-table-column
          align="center"
          label="操作"
          fixed="right"
          width="200px"
        >
          <template slot-scope="scope">
            <div style="display: flex; justify-content: center">
              <button
                v-if="checkPermission(['customerList_import'], permissionLists)"
                class="changeState"
                style="
                  margin-right: 6px;
                  margin-left: 6px;
                  line-height: initial;
                "
                @click="queryImportState(scope.row)"
              >
                导入
              </button>
              <el-tooltip
                v-if="checkPermission(['customerList_export'], permissionLists)"
                effect="dark"
                content="该客户无导入数据不能导出"
                :disabled="!isNull(scope.row.count)"
                placement="top"
              >
                <div style="display: inline-block">
                  <el-button
                    class="changeServe"
                    @click="exportInfo1(scope.row)"
                    :disabled="isNull(scope.row.count)"
                    >导出</el-button
                  >
                </div>
              </el-tooltip>
              <el-tooltip
                effect="dark"
                content="该客户无导入数据不能删除"
                v-if="
                  checkPermission(['customerList_dlt'], permissionLists) &&
                  isNull(scope.row.count)
                "
                placement="top"
              >
                <div style="display: inline-block">
                  <el-button
                    class="pinkButton"
                    style="margin-left: 6px"
                    :disabled="isNull(scope.row.count)"
                    >删除</el-button
                  >
                </div>
              </el-tooltip>
              <el-tooltip
                effect="dark"
                content="暂时无法删除，请联系您的上级主管"
                v-if="
                  checkPermission(['customerList_dlt'], permissionLists) &&
                  isBtnHandle == '0' &&
                  !isNull(scope.row.count)
                "
                placement="top"
              >
                <div style="display: inline-block">
                  <el-button
                    class="pinkButton"
                    style="margin-left: 6px"
                    :disabled="isBtnHandle == '0'"
                    >删除</el-button
                  >
                </div>
              </el-tooltip>
              <el-popconfirm
                confirm-button-text="确认删除"
                icon="el-icon-info"
                icon-color="red"
                v-if="
                  checkPermission(['customerList_dlt'], permissionLists) &&
                  !isNull(scope.row.count) &&
                  isBtnHandle == '1'
                "
                @confirm="delHandle(scope.row)"
                :title="
                  '请确认是否删除' +
                  scope.row.StrObjName +
                  '的所有数据？该操作不可逆，请谨慎操作！'
                "
              >
                <el-button
                  slot="reference"
                  class="pinkButton"
                  style="margin-left: 6px"
                  :disabled="isNull(scope.row.count)"
                  >删除</el-button
                >
              </el-popconfirm>
              <!-- <el-tooltip v-if="isCanHandle" effect="dark" content="开启小程序地图权限" placement="top">
                  <div style="display:inline-block;margin-left:6px">
                    <el-button v-if="scope.row.Strwxwork != '开启'" type="success" size="mini" plain @click="openApplet(scope.row, '开启', 'map')">开启地图</el-button>
                  </div>
                </el-tooltip>
                <el-tooltip v-if="isCanHandle" effect="dark" content="关闭小程序地图权限" placement="top">
                  <div style="display:inline-block;">
                    <el-button v-if="scope.row.Strwxwork == '开启'" type="success" size="mini" plain @click="openApplet(scope.row, '关闭', 'map')">关闭地图</el-button>
                  </div>
                </el-tooltip>
                <el-tooltip v-if="isCanHandle" effect="dark" content="开启小程序离职权限" placement="top">
                  <div style="display:inline-block;margin-left:6px">
                    <el-button v-if="scope.row.Strwxquit != '开启'" type="primary" size="mini" plain @click="openApplet(scope.row, '开启', 'quit')">开启离职</el-button>
                  </div>
                </el-tooltip>
                <el-tooltip v-if="isCanHandle" effect="dark" content="关闭小程序离职权限" placement="top">
                  <div style="display:inline-block;">
                    <el-button v-if="scope.row.Strwxquit == '开启'" type="primary" size="mini" plain @click="openApplet(scope.row, '关闭', 'quit')">关闭离职</el-button>
                  </div>
                </el-tooltip> -->
            </div>
            <!-- <a :href="'http://emp.jobkeji.cn/cloudexcel/' + scope.row.excelpath">下载</a> -->
            <!-- <el-button class="pinkButton" @click="revokeImport(scope.row)" :disabled="isNull(scope.row.count)">撤销导入</el-button> -->
          </template>
        </el-table-column>
      </el-table>
      <div class="block" v-if="totalcount > 0">
        <el-pagination
          @current-change="handleCurrentChange"
          @size-change="handleSizeChange"
          :current-page.sync="currentPage"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="pageSize"
          layout="total,sizes,prev,pager, next, jumper"
          :total="totalcount"
        ></el-pagination>
      </div>
    </div>
    <div class="dialog">
      <!-- 导入模板下载 -->
      <el-dialog :visible.sync="dialogVisible3" width="480px">
        <div class="diaTitle">导入模板下载</div>
        <div style="padding: 10px 0px 20px">
          <p>注：所有日期格式都是YYYY-MM-DD格式</p>
          <a :href="this.modepath">点击下载</a>
        </div>
        <span slot="footer" class="dialog-footer">
          <button class="clear" @click="dialogVisible3 = false">取消</button>
          <button
            class="search"
            @click="dialogVisible3 = false"
            style="margin-left: 10px; font-weight: 600"
          >
            <a :href="this.modepath" style="font-weight: 600; color: #19bd92"
              >点击下载</a
            >
          </button>
        </span>
      </el-dialog>
      <el-dialog
        :visible.sync="visibleReading"
        width="700px"
        :show-close="false"
        :close-on-click-modal="false"
      >
        <div class="diaTitle">导入说明</div>
        <div style="margin-top: 15px; padding-bottom: 15px">
          <div class="note-txt">
            <p class="tips redtips">● 线下花名册：各客服编辑的Excel文档。</p>
            <p class="tips redtips">
              ● 存档花名册：等于线下花名册导入数据，每月25号到次月2号导入。
            </p>
            <p class="tips redtips">
              ● 招聘管理-流程数据：等于线下花名册导入数据 + 招聘流程数据。
            </p>
            <p class="tips">● 运营报表数据：根据招聘流程数据生成。</p>
            <p class="tips">● 提示说明</p>
            <p style="padding-left: 25px; margin-top: 5px">
              1. 如员工信息变更时，需线下花名册和招聘流程数据同时变更。
            </p>
            <p style="padding-left: 25px; margin-top: 5px">
              2.
              如A员工身份证号一致，线下花名册导入后线下花名册会覆盖招聘流程数据；若A员工身份证号不一致，2号导入后两条数据在流程中分别显示。
            </p>
          </div>
        </div>
        <div
          style="
            display: flex;
            justify-content: flex-end;
            -webkit-justify-content: flex-end;
            padding-bottom: 30px;
          "
        >
          <el-button
            type="primary"
            size="small"
            :disabled="countdown > 0"
            @click="closeRead"
            >继续 {{ countdown == 0 ? "" : "（" + countdown + "）" }}</el-button
          >
        </div>
      </el-dialog>
      <!-- 导入 -->
      <el-dialog :visible.sync="dialogVisible5" width="700px">
        <div class="diaTitle">导入数据 至 {{ exportName }}</div>
        <el-steps :active="active" finish-status="success" class="steps-box">
          <!-- <el-step title="导入说明"></el-step> -->
          <el-step title="基础信息"></el-step>
          <el-step title="上传导入文件"></el-step>
          <el-step title="导入处理"></el-step>
        </el-steps>
        <p
          style="color: #303133; font-weight: bold; margin: 5px 0"
          v-if="active > 0"
        >
          备注：导入时间截止到每月2号23:59分。
        </p>
        <!-- <div v-if="active==0" style="margin-top:15px;padding-bottom:15px;">
          <div class="note-txt">
            <p class="tips redtips">● 线下花名册：各客服编辑的Excel文档。</p>
            <p class="tips redtips">● 存档花名册：等于线下花名册导入数据，每月25号到次月2号导入。</p>
            <p class="tips redtips">● 招聘管理-流程数据：等于线下花名册导入数据 + 招聘流程数据。</p>
            <p class="tips">● 运营报表数据：根据招聘流程数据生成。</p>
            <p class="tips">● 提示说明</p>
            <p style="padding-left: 25px;;margin-top: 5px;">1. 如员工信息变更时，需线下花名册和招聘流程数据同时变更。</p>
            <p style="padding-left: 25px;margin-top: 5px;">2. 如A员工身份证号一致，线下花名册导入后线下花名册会覆盖招聘流程数据；若A员工身份证号不一致，2号导入后两条数据在流程中分别显示。</p>
          </div>
        </div> -->
        <div v-if="active == 0" style="margin-top: 15px; padding-bottom: 15px">
          <div class="flex">
            <div>
              <div>导入表格:</div>
              <div class="storageArea">
                <div class="storageInput" style="margin: 0 20px 0 0">
                  <el-select
                    v-model="tabName"
                    slot="prepend"
                    placeholder="请选择"
                    disabled
                    filterable
                    @change="selectTab"
                  >
                    <el-option
                      v-for="(item, index) in this.tableList"
                      :key="index"
                      :label="item.StrTableName"
                      :value="{
                        value: item.StrTableId,
                        label: item.StrTableName,
                      }"
                    ></el-option>
                  </el-select>
                </div>
              </div>
            </div>
            <div style="margin-left: 150px">
              <div>导入模板下载:</div>
              <el-button
                type="text"
                @click="downLoadHandle"
                style="margin-left: 15px; height: 30px; margin-top: 10px"
                >下载模板</el-button
              >
            </div>
          </div>
        </div>
        <div v-if="active == 1" style="margin-top: 15px; padding-bottom: 15px">
          <div class="note-txt">
            <p style="font-weight: bold">上传文件说明：</p>
            <p>1. 支持文件后缀 xls、xlsx文件。</p>
            <p>2. 请将要上传的内容放在第一个sheet中。</p>
            <p>3. 请不要加密模板文件，将导致错误。</p>
            <p>4. 请不要上传带宏的文件，将导致错误。</p>
            <p>5. 请不要过多的使用格式，如背景色和边框，将可能导致超时。</p>
            <p>
              6.
              导入后只会保留Excel中的数据及通过公式计算后的值，设置的文字颜色等样式、合并的单元格、以及计算公式本身都不会被保留。
            </p>
          </div>
          <div style="margin-top: 10px">请选择导入文件（xls/xlsx格式）:</div>
          <div class="form-item" style="justify-content: space-between">
            <div class="file-box">
              <input
                readonly
                style="width: 368px; height: 32px"
                id="applyLicense"
                type="text"
                v-model="ExcelSrc.fileName"
                autocomplete="off"
              />
              <input
                id="fileInput"
                type="file"
                name="file"
                accept=".xlsx,.xls"
                @change="importf(this)"
                ref="upload"
              />
              <label for="fileInput" class="file-btn">上传</label>
            </div>
          </div>
          <!-- 提示 -->
          <p style="color: red" v-if="isError">{{ errorTxt }}</p>
          <div class="reimpArea">
            <div style="margin-top: 10px">
              <!-- <el-checkbox v-model="isReset" @change="selectReimp">是否覆盖导入</el-checkbox> -->
              <!-- <el-radio v-model="reimpLab" label="0" border size="small" @change="selectReimp">否</el-radio>
                <el-radio v-model="reimpLab" label="1" border size="small" @change="selectReimp">是</el-radio> -->
            </div>
          </div>
        </div>
        <div v-if="active == 2" style="margin-top: 15px; padding-bottom: 15px">
          <div class="result-box">
            <p>
              <i
                class="el-icon-success"
                style="color: #409eff; margin-right: 5px"
              ></i
              >导入数据正在处理中，导入结果请在’导入记录‘中查看。
            </p>
          </div>
          <!-- <span slot="footer" class="dialog-footer">
            <button class="clear" @click="dialogVisible5 = false">取消</button>
            <button
              class="search"
              @click="confirmImport"
              type="primary"
              v-loading.fullscreen.lock="fullscreenLoading"
              :element-loading-text="'已导入'+this.process +'%'"
              style="margin-left:10px;font-weight:600"
            >确定</button>
          </span> -->
        </div>
        <div
          style="
            display: flex;
            justify-content: flex-end;
            -webkit-justify-content: flex-end;
            padding-bottom: 30px;
          "
        >
          <el-button
            size="small"
            @click="dialogVisible5 = false"
            v-if="active == 0"
            >取消</el-button
          >
          <el-button
            size="small"
            @click="prevSteps"
            v-if="active > 0 && active <= 1"
            >上一步</el-button
          >
          <el-button
            type="primary"
            size="small"
            @click="nextSteps"
            v-if="active < 1"
            >下一步</el-button
          >
          <el-tooltip
            effect="dark"
            content="未上传文件不能提交"
            :disabled="!isUploadSuccess"
            placement="top"
          >
            <div style="display: inline-block; margin-left: 10px">
              <el-button
                type="success"
                size="small"
                @click="lastSteps"
                element-loading-text="此操作可能耗费较长时间，请等待..."
                element-loading-spinner="el-icon-loading"
                element-loading-background="rgba(0, 0, 0, 0.8)"
                v-loading.fullscreen.lock="fullscreenLoading"
                v-if="active == 1"
                :disabled="isUploadSuccess"
                >提交</el-button
              >
            </div>
          </el-tooltip>
          <el-button
            type="primary"
            size="small"
            @click="backHandle"
            v-if="active == 3"
            >确认并返回</el-button
          >
          <el-button size="small" @click="resultHandle" v-if="active == 2"
            >查看导入结果</el-button
          >
        </div>
        <!-- <input type="file" @change="importf(this)" ref="upload" accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"> -->
      </el-dialog>
      <!-- 导入成功 -->
      <el-dialog :visible.sync="dialogVisible6" width="480px">
        <div class="successBox">
          <div class="successImg">
            <img src="./../../../assets/employee/images/success.png" />
          </div>
          <div class="successText">
            导入成功
            <span v-if="this.errorColumn.length > 0"
              >但导入的数据格式有错误，请修改正确后重新导入</span
            >
          </div>
          <div
            class="importNum2"
            @click="dialogVisible9 = true"
            v-if="this.errorColumn.length > 0"
          >
            本次导入共有{{
              this.errorColumn.length
            }}条格式错误数据，查看格式错误数据的行列
          </div>
          <div class="importNum" v-else>
            本次共导入{{ this.totalmain }}条雇员信息
          </div>
        </div>
        <span slot="footer" class="dialog-footer">
          <button class="clear" @click="dialogVisible6 = false">完成</button>
          <button
            class="search"
            @click="reImport()"
            v-if="this.errorColumn.length > 0"
            style="margin-left: 10px; font-weight: 600"
          >
            重新导入
          </button>
          <button
            class="search"
            @click="dialogVisible6 = false"
            v-else
            style="margin-left: 10px; font-weight: 600"
          >
            查看导入数据
          </button>
        </span>
      </el-dialog>
      <!-- 错误行列 -->
      <el-dialog :visible.sync="dialogVisible9" width="70%">
        <div class="errorColumn">
          <div
            class="errorColumnItem"
            v-for="(item, index) in this.errorColumn"
            :key="index"
          >
            {{ item }}
          </div>
        </div>
      </el-dialog>
      <!-- 撤销导入 -->
      <el-dialog :visible.sync="dialogVisible2" width="384px">
        <div class="delTitle">撤销导入</div>
        <div style="padding: 10px">
          您正在对客户“{{
            exportName
          }}进行撤销导入操作”，撤销后结果不可逆，请谨慎操作！”
        </div>
        <span slot="footer" class="dialog-footer">
          <button class="clear" @click="dialogVisible2 = false">取消</button>
          <button
            class="search"
            @click="UndoImport"
            style="margin-left: 10px; font-weight: 600"
          >
            确定
          </button>
        </span>
      </el-dialog>
      <!-- 在离职状态选择 -->
      <el-dialog :visible.sync="expSelectDialog" width="480px">
        <div class="delTitle">选择导出人员在/离职状态</div>
        <div>
          <div class="dataSele">
            <el-select
              v-model="workState"
              slot="prepend"
              placeholder="请选择"
              filterable
            >
              <el-option label="全部" value=""></el-option>
              <el-option value="在职"></el-option>
              <el-option value="离职"></el-option>
              <el-option value="离职转正"></el-option>
              <el-option value="自离"></el-option>
            </el-select>
          </div>
        </div>
        <span slot="footer" class="dialog-footer">
          <button class="clear" @click="expSelectDialog = false">关闭</button>
          <button
            class="search"
            @click="exportInfo2(rowinfo)"
            style="margin-left: 10px; font-weight: 600"
          >
            导出
          </button>
        </span>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import { VueTreeList, Tree } from "vue-tree-xz";
import FUN from "./../../../fun";
import checkPermission from "@/utils/permission"; // 权限判断函数
import xz from "./../../../common";
export default {
  props: {
    toChildrenData: {
      type: Object,
      default() {
        return {};
      },
    },
    toPermissionLists: {
      type: Array,
      default() {
        return {};
      },
    },
    toFieldList: {
      type: Array,
      default() {
        return {};
      },
    },
  },
  components: {
    VueTreeList,
  },
  data() {
    return {
      //是否下载过导入模板
      isDownload: false,
      rowinfo: null,
      //在/离职状态
      workState: "在职",
      //导出弹窗
      expSelectDialog: false,
      //角色类型
      roleType: "",
      tablePath: this.$store.state.EMP.tablePath,
      tableHeight: 0,
      checkedFields: [],
      fixedfields: [],
      otherfields: [],
      tableclumn: [],
      isIndeterminate: true,
      //表头错误提示
      isError: false,
      errorTxt: "",
      listLoading: false,
      //导入模板链接
      modepath: "",
      //导入到的项目名称
      exportName: "",
      //是否覆盖
      isReset: false,
      errorColumn: [],
      totalmain: "",
      pageSize: 10,
      //下级人员列表
      subordinateList: [],
      //已选择的下级
      selectedSubordinate: null,
      //页面展示数量
      pagecount: 10,
      //第几页
      currpage: 1,
      //数据数量
      totalcount: null,
      //导入步骤
      active: 0,
      visibleReading: true,
      //文件是否已上传
      isFileSuccess: false,
      //文件
      files: "",
      fileName: "",
      searchDown: "",
      ExcelSrc: {
        value: "",
        check: false,
        fileName: "",
      },
      entid: "",
      excelpath: "",
      showResult: false,
      fullscreenLoading: false,
      infoPath: "",
      currentPage: 1,
      select: "",
      instname: "",
      process: 0,
      reimp: 0,
      reimpLab: "0",
      StrUserName: "",
      StrSrvCent: "",
      StrObjName: "",
      //下拉筛选
      showDropScreen: -1,
      // dialogVisible: false,
      //撤下导入
      dialogVisible2: false,
      //导入模板下载
      dialogVisible3: false,
      //导出
      dialogVisible4: false,
      //导入
      dialogVisible5: false,
      //导入成功
      dialogVisible6: false,
      dialogVisible9: false,
      pageSet: false,
      interval: null,
      tabName: { label: "雇员信息表", value: "XZ_emp_UserBase" },
      tabId: "",
      tableList: [
        {
          StrTableId: "XZ_emp_UserBase",
          StrTableName: "雇员信息表",
        },
      ],
      tableData: [],
      //下拉服务中心列表
      serviceList: [],
      //下拉业务立项部门
      apartmentList: [],
      //列表参数
      infoQuery: {
        pagecount: 10,
        currpage: 1,
        objname: "", //项目名称
        ctluserid: "",
        strsrvcent: "", //服务中心
        strobjinstname: "", //立项部门
        strusername: "", //客服名称
        strbusistat: "", //服务状态
        stremptype: "0",
        roletype: "",
      },
      //上传excel是否成功-判断下一步按钮是否禁用
      isUploadSuccess: true,
      allFieldList: [],
      //导入状态查询参数
      stateInfoQuery: {
        pagecount: 10,
        currpage: 1,
        excelname: "",
        tableid: "XZ_emp_UserBase",
        instname: "",
        datestart: "",
        dateend: "",
        objname: "",
        strobjinstname: "",
        strusername: "",
        impdate: "",
      },
      //判断提交导入是否有返回
      isComeBack: false,
      // 修改权限参数
      wxQuery: {
        strwxwork: "", // 是否开启地图找工作权限
        strwxquit: "", // 是否开启离职权限
        gdObjId: "",
      },
      // 是否有权限操作按钮
      isCanHandle: false,
      // 是否可导入或删除
      isBtnHandle: "0", // 0不可1可
      countdown: 30,
      monthFirstDates: "",
      permissionLists: [], //按钮权限列表
    };
  },
  created() {
    // console.log('toChildrenData', this.toPermissionLists)
    // this.isCanHandle = this.toIsCanHandle
    // this.allFieldList = this.toFieldList
    this.infoQuery.roletype = localStorage.loginRoletype;
    this.printFile(this.toFieldList);
    this.printButton(this.toPermissionLists);
    this.isHandleList();
    if (window.localStorage.getItem("loginRoletype")) {
      this.roleType = window.localStorage.getItem("loginRoletype");
    }
    if (window.localStorage.getItem("isDownload")) {
      this.calDaysBetween(window.localStorage.getItem("isDownload"));
    }
    this.calHeight();
    let dateMoments = new Date();
    this.monthFirstDates =
      dateMoments.getFullYear() +
      "-" +
      (dateMoments.getMonth() + 1) +
      "-" +
      dateMoments.getDate();
    if (
      window.localStorage.getItem("visibleReadingCustomer") !=
        this.monthFirstDates &&
      (this.checkPermission(['customerList_import'], this.permissionLists)&&(localStorage.loginRoletype.indexOf('adm')==-1))
    ) {
      this.visibleReading = true;
      this.countdown = 30;
      this.timecount();
    } else {
      this.visibleReading = false;
    }
  },
  mounted() {},
  computed: {
    searchResult() {
      if (this.$store.state.ADDCOMPANY.customerMatch.length > 0) {
        this.showResult = true;
      }
      return this.$store.state.ADDCOMPANY.customerMatch;
    },
  },
  methods: {
    checkPermission,
    calHeight() {
      this.tableHeight = Number(document.body.clientHeight);
      // console.log('height', this.tableHeight)
    },
    // 父组件传值按钮权限给子组件的值
    printButton(val) {
      // console.log('printButton', val)
      this.permissionLists = val;
    },
    // 父组件传值按钮权限给子组件的值(导出字段)
    printFile(val) {
      // console.log(val)
      this.allFieldList = val;
    },
    // 是否开启小程序权限
    openApplet(item, isOpen, type) {
      // console.log("dsad", item);
      // 地图
      if (type == "map") {
        this.wxQuery.strwxwork = isOpen;
        this.wxQuery.strwxquit = item.Strwxquit;
      }
      // 离职
      if (type == "quit") {
        this.wxQuery.strwxwork = item.Strwxwork;
        this.wxQuery.strwxquit = isOpen;
      }
      this.wxQuery.gdObjId = item.GdObjId;
      // console.log('kkk', this.wxQuery)
      this.$confirm("此操作将修改小程序权限，是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          xz.updateEmpCustListWx(this.wxQuery).then((res) => {
            // console.log('resetMember', res)
            if (res.status == "ok") {
              this.$message({ type: "success", message: "操作成功" });
              this.getCustomerList(this.toChildrenData);
            } else {
              this.$message({ type: "warning", message: "操作失败" });
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消修改",
          });
        });
    },
    // 判断是否可导入或删除
    isHandleList() {
      xz.getSystemConfig().then((res) => {
        // console.log('kk',res)
        if (res.status == "ok") {
          this.isBtnHandle = res.msg;
        }
      });
    },
    //删除导入数据
    delHandle(row) {
      const data = {
        strObjName: row.StrObjName,
      };
      xz.delempuserimport(data).then((res) => {
        if (res) {
          this.$message.success("删除成功！数据删除可能会有延迟");
          setTimeout(() => {
            this.getCustomerList(this.toChildrenData);
          }, 1000);
        } else {
          this.$message.failed("删除失败！请联系管理员");
        }
      });
    },
    pagechange(d) {
      // console.log('q',this.pagecount)
      this.pagecount = parseInt(this.toChildrenData.pagecount);
      window.localStorage.setItem("page", this.toChildrenData.pagecount);
      this.pageSet = false;
      this.getCustomerList(this.toChildrenData);
    },
    //下一步导入
    nextSteps() {
      // if (this.active++ > 2) this.active = 0;
      if (this.active == 0) {
        if (this.tabName == "") {
          this.$message({
            message: "请选择导入模板",
            type: "warning",
          });
          this.active = 0;
          return false;
        }
        // if (!this.isDownload) {
        //   this.$message({
        //     message: "请先下载导入模板，下一步导入请使用新的模板导入",
        //     type: "warning",
        //     duration: 5000
        //   });
        //   return false
        // }
      }
      this.active += 1;
    },
    //上一步导入
    prevSteps() {
      this.active -= 1;
    },
    handleClose() {
      if (this.countdown > 0) {
        return;
      }
    },
    //提交导入
    async lastSteps() {
      if (this.ExcelSrc.value == "") {
        this.isUploadSuccess = true;
        this.$message({
          message: "请选择文件上传",
          type: "warning",
        });
        this.active = 1;
        return false;
      }
      // else if(this.isComeBack == true){
      //     this.$message({
      //     message: "上传的文件正在导入中，请勿重复提交",
      //     type: "warning"
      //   });
      //   this.active = 1
      //   return false
      //   }
      else {
        //检查表头是否正确
        let checkData = {
          excelpath: this.excelpath,
          tableid: "XZ_emp_UserBase",
        };
        // console.log('checkData', checkData)
        this.fullscreenLoading = true;
        xz.chkimpdatatbtype(checkData).then((res) => {
          // console.log('checkData',res)
          // //第一个冒号出现的位置
          // let firstIndex = res.indexOf(":")
          // //根据第一个点的位置 获得第二个点的位置
          // let secondIndex = res.indexOf(":", firstIndex + 1)
          // //根据第二个点的位置，截取 字符串。
          // let resultTxt = res.slice(Number(secondIndex + 2), -2)
          let resultTxt = res;
          // console.log('resultTxt',this.isNull(res))
          if (this.isNull(res)) {
            this.isError = false;
            this.isUploadSuccess = false;
            const Edata = {
              instname: this.instname,
              tableid: "XZ_emp_UserBase",
              // impexcel:"雇员信息表",
              reimp: this.reimp,
              excelpath: this.excelpath,
              impexcel: this.ExcelSrc.fileName,
              servusrname: this.StrUserName,
              servcentname: this.StrSrvCent,
              custname: this.StrObjName,
            };
            xz.returnExcelSrc(Edata).then((res) => {
              // console.log('Edata', res)
              if (res) {
                // this.$router.push({
                //   path: "/operationRecord",
                //   query: {}
                // })
                this.active = 2;
              } else {
                this.$message("导入错误");
              }
              this.fullscreenLoading = false;
              // this.isUploadSuccess = true
            });
          } else {
            this.isError = true;
            this.active = 1;
            this.isUploadSuccess = true;
            this.errorTxt = resultTxt;
            //导入操作，如果第一次导入某个文件会触发导入操作，但是第二次导入重复该文件，不会触发操作
            //清空input file值
            var file = document.getElementById("fileInput");
            file.value = "";
            // this.$message({
            //   message: res.msg,
            //   type: "warning"
            // });
            this.fullscreenLoading = false;
          }
        });
      }
    },
    //判断是否为空(包含0)
    isNull(o) {
      return (
        o == undefined ||
        o == "undefined" ||
        (o + "").indexOf("undefined") > -1 ||
        o == null ||
        o == "" ||
        o == "null" ||
        o == [] ||
        o == 0 ||
        o == "NaN"
      );
    },
    //导入-确认返回
    backHandle() {
      this.dialogVisible5 = false;
      this.getCustomerList(this.toChildrenData);
    },
    //查看导入结果
    resultHandle() {
      this.dialogVisible5 = false;
      this.$router.push({
        path: "/operationRecord",
      });
    },
    //下载模板
    downLoadHandle() {
      xz.getImportMode().then((res) => {
        // console.log('下载模板', res)
        if (res) {
          this.isDownload = true;
          window.localStorage.setItem("isDownload", new Date());
          var d = res.msg.data.StrOutPath;
          d = d.replace('"', "").replace('"', "");
          var path = this.tablePath + d;
          const aTag = document.createElement("a");
          aTag.href = path;
          aTag.click();
        }
      });
    },
    calDaysBetween(date) {
      let startDate = Date.parse(date);
      let endDate = Date.parse(new Date());
      let days = (endDate - startDate) / (1 * 24 * 60 * 60 * 1000);
      days > 7 ? (this.isDownload = false) : (this.isDownload = true);
    },
    handleCurrentChange(val) {
      // console.log(`当前页: ${val}`);
      this.infoQuery.currpage = Number(`${val}`);
      this.toChildrenData.currpage = Number(`${val}`);
      // console.log('page',this.currpage)
      this.getCustomerList(this.toChildrenData);
    },
    handleSizeChange(val) {
      // console.log(`每页 ${val} 条`);
      this.infoQuery.pagecount = Number(`${val}`);
      this.toChildrenData.pagecount = Number(`${val}`);
      this.pageSize = parseInt(val);
      this.getCustomerList(this.toChildrenData);
    },
    serviceChange() {
      this.getApartmentList(
        this.toChildrenData.strsrvcent,
        this.toChildrenData.strobjname
      );
    },
    //点击客户转跳到客户花名册
    handdle(row) {
      // console.log(row, event, column, cell)
      let instname = row.StrObjInstName;
      let servusrname = row.StrUserName;
      let servcentname = row.StrSrvCent;
      let custname = row.StrObjName;
      let entid = row.GdObjId;
      this.$router.push({
        path: "/employee-customerRoster",
        query: {
          instname,
          servusrname,
          servcentname,
          custname,
          entid,
        },
      });
    },
    //撤销导入
    revokeImport(item) {
      this.exportName = item.StrObjName;
      this.dialogVisible2 = true;
    },
    //确定撤销导入
    UndoImport() {
      xz.empUndoinputData(this.exportName).then((res) => {
        // console.log('撤销导入',res)
        if (res.status == "ok") {
          this.$message({
            message: "撤销导入成功",
            type: "success",
          });
          this.dialogVisible2 = false;
          this.$store.commit("getLeftNum");
          this.getCustomerList(this.toChildrenData);
        } else {
          this.$message({
            message: "撤销导入失败",
            type: "warning",
          });
        }
      });
    },
    columnStyle({ row, column, rowIndex, columnIndex }) {
      if (column.label == "项目名称") {
        return "cursor: pointer";
      }
    },
    //查询导入状态
    queryImportState(val) {
      this.stateInfoQuery.strsrvcent = val.StrSrvCent;
      this.stateInfoQuery.strobjname = val.StrObjName;
      if (this.isBtnHandle == "0") {
        this.$message({
          message: "暂时无法导入，请联系您的上级主管",
          type: "warning",
        });
        return false;
      }
      xz.getPathInfo(this.stateInfoQuery).then((res) => {
        if (res) {
          if (res.data.length > 0) {
            let opTime =
              res.data[0].StrImpBdateStr.substring(0, 4) +
              "/" +
              res.data[0].StrImpBdateStr.substring(4, 6) +
              "/" +
              res.data[0].StrImpBdateStr.substring(6, 8) +
              " " +
              res.data[0].StrImpBdateStr.substring(8, 10) +
              ":" +
              res.data[0].StrImpBdateStr.substring(10, 12);
            if (
              new Date().getTime() >
              new Date(new Date(opTime).valueOf() + 360000).getTime()
            ) {
              this.importInfo(val);
            } else {
              if (
                res.data[0].StrImpEdateStr != null &&
                res.data[0].StrImpEdateStr != "20" &&
                res.data[0].StrImpEdateStr != "40" &&
                res.data[0].StrImpEdateStr != "60" &&
                res.data[0].StrImpEdateStr != "80"
              ) {
                // console.log('stateSuccess')
                this.importInfo(val);
              } else {
                this.$message({
                  message: "您有一条正在导入的记录，请在导入完成后再导入",
                  duration: 5000,
                  type: "warning",
                });
              }
            }
          } else {
            this.importInfo(val);
          }
        } else {
          this.$message.error("系统出错，请联系管理员");
        }
      });
    },
    //导入
    importInfo(val) {
      this.dialogVisible5 = true;
      this.errorTxt = "";
      this.ExcelSrc = {
        value: "",
        check: false,
        fileName: "",
      };
      // this.tabName=''
      this.exportName = val.StrObjName;
      this.active = 0;
      // console.log('info', val)
      this.infoPath = "雇员花名册>" + val.StrSrvCent + ">" + val.StrObjName;
      this.entid = Cookies.get("userid-b");
      this.instname = val.StrObjInstName;
      this.StrUserName = val.StrUserName;
      this.StrSrvCent = val.StrSrvCent;
      this.StrObjName = val.StrObjName;
    },
    timecount() {
      const TIME_COUNT = 10; //倒计时30秒
      if (!this.timer) {
        this.countdown = TIME_COUNT;
        this.isDisabled = true;
        this.timer = setInterval(() => {
          if (this.countdown > 0 && this.countdown <= TIME_COUNT) {
            this.countdown--;
          } else {
            clearInterval(this.timer);
            this.timer = null;
          }
        }, 1000);
      }
    },
    //重新导入
    reImport() {
      this.dialogVisible6 = false;
      this.dialogVisible5 = true;
      this.countdown = 30;
      this.timecount();
    },
    exportInfo1(row) {
      this.rowinfo = row;
      this.expSelectDialog = true;
    },
    //导出
    exportInfo2(row) {
      // this.dialogVisible4 = true;
      const data = {
        strworkstate: this.workState,
        custname: row.StrObjName,
        outtype: "0",
        tableid: "XZ_emp_UserBase",
        roletype: localStorage.loginRoletype,
        tableclumn: this.allFieldList,
      };
      // console.log('导出', data)
      var Promise = xz.exportEmp(data);
      this.$router.push({
        path: "/operationRecord",
        query: {
          showPage: 1,
          isActive: 1,
          custname: row.StrObjName,
          //qStstus=1时查看最后一条导出记录
          qStstus: 1,
        },
      });
    },
    //去重
    unique(arr) {
      const resList = new Map();
      return arr.filter(
        (arr) => !resList.has(arr.name) && resList.set(arr.name, 1)
      );
    },
    //文件读取
    async importf() {
      const fileInput = this.$refs.upload;
      this.excelpath = "";
      //上传前先删除旧的
      xz.delempuserimport({ strObjName: this.exportName }).then((res) => {
        if (res) {
          FUN.returnExcelSrc(fileInput).then((src) => {
            if (src) {
              // console.log('src0o0', src)
              this.isFileSuccess = true;
              this.$set(this.ExcelSrc, "value", src.src);
              this.$set(this.ExcelSrc, "check", false);
              this.$set(this.ExcelSrc, "fileName", fileInput.files[0].name);
              // console.log('srccc', this.ExcelSrc)
              //上传excel
              const excelFile = FUN.base64ToFile(
                this.ExcelSrc.value,
                this.ExcelSrc.fileName
              );
              const formData = new FormData();
              formData.append("pagename", "empexcel");
              formData.append("action", "save");
              formData.append("userid", Cookies.get("userid-b"));
              formData.append("entid", this.entid);
              formData.append("excel", excelFile, this.ExcelSrc.fileName);
              console.log("formData", formData);
              xz.uploadCert(formData).then((res) => {
                // console.log('formData', res)
                // this.excelpath = res;
                if (this.isNull(res) || res == false) {
                  this.$message("上传Excel失败!");
                  this.isUploadSuccess = true;
                } else {
                  this.errorTxt = "";
                  this.excelpath = res;
                  localStorage.setItem("epath", res);
                  this.isUploadSuccess = false;
                  this.$refs['upload'].value = null;
                  // this.interval=setInterval(this.inquireImportProcess,5000)
                }
              });
            } else {
              this.$message("上传Excel失败!");
            }
          });
        } else {
          this.$message.failed("操作失败！");
        }
      });
    },
    inquireImportProcess() {
      var path = this.excelpath;
      xz.getImportProcess(path).then((res) => {
        // console.log('process', res)
        this.process = res.process;
        if (res.process == 100) {
          clearInterval(this.interval);
          // this.getErrorColumn();
          this.totalmain = res.totalmain;
          this.fullscreenLoading = false;
          this.dialogVisible5 = false;
          this.dialogVisible6 = true;
        }
      });
    },
    // 下拉选择表格
    selectTab(d) {
      this.tabId = d.value;
      this.tabName = d.label;
      // console.log("d", d);
    },
    // 下拉选择是否覆盖
    selectReimp(d) {
      if (d == true) {
        this.reimp = 1;
        this.reimpLab = 1;
      } else {
        this.reimp = 0;
        this.reimpLab = 0;
      }
      // console.log("d", d, this.reimpLab);
    },
    getCustomerList(query) {
      // console.log('info',this.infoQuery)
      this.listLoading = true;
      xz.customerInfo(query).then((res) => {
        // console.log('getres', res)
        if (res) {
          if(res.countinf && res.countinf.length>0){
            for (var i = 0; i < res.countinf.length; i++) {
              var NotWork =
                Number(res.countinf[i].count) -
                Number(res.countinf[i].IsWorkCount);
              var IsBlack = res.countinf[i].IsWhiteCount;
              res.data[i]["NotWork"] = NotWork;
              res.data[i]["IsBlack"] = IsBlack;
              res.data[i]["count"] = parseInt(res.countinf[i].count);
              res.data[i]["IsWork"] = parseInt(res.countinf[i].IsWorkCount);
              res.data[i]["EmpNotSalary"] = res.countinf[i].EmpNotSalary;
              res.data[i]["excelpath"] = res.countinf[i].excelpath;
            }
          }
          this.tableData = res.data;
          // console.log('getres', this.tableData)
          this.showDropScreen = -1;
          this.totalcount = parseInt(res.totalcount);
        } else {
          this.tableData = [];
          this.showDropScreen = -1;
        }
        //子组件传给父组件的值
        this.$emit("func", this.tableData);
        this.listLoading = false;
      });
    },
    closeRead() {
      this.visibleReading = false;
      window.localStorage.setItem(
        "visibleReadingCustomer",
        this.monthFirstDates
      );
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.page-customer .pinkButton {
  padding: 5px 10px;
  line-height: initial;
  border: solid 1px #ff6780;
  font-size: 12px;
  color: #ff6780;
  border-radius: 4px;
  background-color: #fff;
}
.page-customer .changeServe {
  padding: 5px 10px;
  line-height: initial;
  border: solid 1px #19bd92;
  font-size: 12px;
  color: #19bd92;
  border-radius: 4px;
  background-color: #fff;
}
.page-customer .el-button.is-disabled {
  color: #c0c4cc;
  cursor: not-allowed;
  background-image: none;
  background-color: #fff;
  border-color: #ebeef5;
}
.result-box {
  padding: 15px 10px;
  border-radius: 5px;
  background-color: rgba(103, 194, 58, 0.1);
}
.form-item {
  width: 100%;
  display: flex;
  align-items: center;
  font-size: 14px;
  color: #333333;
  margin-bottom: 20px;
}
.steps-box {
  margin-top: 20px;
}
.steps-box .el-step__title {
  font-size: 14px;
  color: #999;
}
.form-item label {
  width: 56px;
  text-align: right;
}

.form-item span {
  color: #ff3228;
}
.redtips {
  color: #ff3228;
}

.form-item input {
  width: 400px;
  height: 40px;
  line-height: 40px;
  border: 1px solid #cccccc;
  padding-left: 14px;
  box-sizing: border-box;
  margin-top: 10px;
}

/* 这是原生的input框，给他透明隐藏，然后定位让文件上传的按钮覆盖它 */
#fileInput {
  width: 120px;
  margin-left: 8px;
  filter: Alpha(opacity=0);
  -moz-opacity: 0;
  opacity: 0;
  position: absolute;
  right: 37px;
  z-index: 2;
}
/* 这是主要的，文件上传按钮的样式 */
.file-box {
  position: relative;
}
.file-btn {
  display: inline-block;
  width: 54px;
  height: 30px;
  background: #fff;
  border: 1px solid #ccc;
  /* border-radius:2px; */
  text-align: center !important;
  line-height: 32px;
  color: #333333;
  /* position: absolute;
    top: 5px;
    right: 0; */
  margin-left: 8px;
}
/* 单行文字截断，展示文件名的input框用的 */
#applyLicense {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.tips {
  margin-top: 10px;
}
</style>
